import React, { useEffect, useRef, useState } from "react";
import {
  MDBFile,
  MDBValidationItem,
  MDBCard,
  MDBCheckbox,
  MDBCardTitle,
  MDBCardText,
  MDBCardImage,
  MDBTextArea,
  MDBBtn,
  MDBInput,
} from "mdb-react-ui-kit";
import Header from "../components/Header";
import DatePickerComponent from "../components/DatePickerComponent";
import YearPicker from "../components/YearPicker";
import { toast } from "react-toastify";
import "../styles/registration.css";
import CaptchaGenerator from "./CaptchaGenerator";
import RegistrationHeader from "../components/RegistrationHeader";
import axios from "axios";
import validateAdvocateRegistrationForm from "../utilities/validateAdvocateRegistrationForm";
import Loader from "../components/Loader";
import API_BASE_URL from "../utilities/apiConfig";
import axiosInstance from "../utilities/apiConfig";
import { useSelector } from "react-redux";

const Registration = () => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [isRetiredFromAnyDepartment, setIsRetiredFromAnyDepartment] =
    useState(false);
  const [highestQualification, setHighestQualification] = useState(0);
  const alphabets = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";
  const [captcha, setCaptcha] = useState("");
  const [status, setStatus] = useState("Captcha Generator");
  const [userInput, setUserInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  // const token = useSelector((state) => state.auth.token);
  const advocateRegistrationRequestDetailsAndDocumentsInitialState = {
    name: "",
    relationshipType: "",
    relativeName: "",
    dateOfBirth: "",
    advocateBarId: "",
    registrationDate: "",
    mobileNo: "",
    email: "",
    permanentAddress: "",
    bloodGroup: "",
    mentorAdvocateName: "",
    mentorAdvocateBarId: "",
    mentorJoiningDate: "",
    chamberNo: "",
    isPreviousDepartment: false,
    previousDepartment: "",
    retirementYear: 0,

    highSchoolDocument: "",
    intermediateDocument: "",
    graduationDocument: "",
    postGraduationDocument: "",
    doctrateDocument: "",
    aadharDocument: "",
    affidavitDocument: "",
    aibeCertificate: "",

    highSchoolDegree: "High School",
    highSchoolPassingYear: 0,
    highSchoolDetails: "",

    intermediateDegree: "Intermediate",
    intermediatePassingYear: 0,
    intermediateDetails: "",

    graduationDegree: "",
    graduationPassingYear: 0,
    graduationDetails: "",

    postGraduationDegree: "",
    postGraduationPassingYear: 0,
    postGraduationDetails: "",

    doctrateDegree: "",
    doctratePassingYear: 0,
    doctrateDetails: "",
  };
  const [advocateDetailsAndDocuments, setAdvocateDetailsAndDocuments] =
    useState(advocateRegistrationRequestDetailsAndDocumentsInitialState);

  const handleYearChange = (year) => {
    setSelectedYear(year);
    // Do something with the selected year, e.g., fetch data based on selected year
  };
  const currentYear = new Date().getFullYear();

  const generateCaptcha = () => {
    const first = alphabets[Math.floor(Math.random() * alphabets.length)];
    const second = Math.floor(Math.random() * 10);
    const third = Math.floor(Math.random() * 10);
    const fourth = alphabets[Math.floor(Math.random() * alphabets.length)];
    const fifth = alphabets[Math.floor(Math.random() * alphabets.length)];
    const sixth = Math.floor(Math.random() * 10);
    const newCaptcha = `${first}${second}${third}${fourth}${fifth}${sixth}`;
    setCaptcha(newCaptcha);
    setUserInput("");
    setStatus("Fill Captcha Before Form Submission");
    setIsCaptchaVerified(false);
  };

  const checkCaptcha = (e) => {
    e.preventDefault();
    if (userInput === captcha) {
      setStatus("Correct!!");
      setIsCaptchaVerified(true);
      handleSubmitRegistrationForm(e);
      setUserInput("");
    } else {
      generateCaptcha();
      setStatus("Try Again!!");
      setIsCaptchaVerified(false);
      setUserInput("");
    }
  };

  // const handleInputFieldChange = (e) => {
  //   console.log(e);
  //   const { value, name } = e.target;

  //   setAdvocateDetailsAndDocuments({
  //     ...advocateDetailsAndDocuments,
  //     [name]: value,
  //   });
  // };

  const [barIdError, setBarIdError] = useState("");

  const handleInputFieldChange = (e) => {
    const { value, name } = e.target;

    // Regex pattern for validation
    const barIdPattern = /^[A-Za-z]{2}\s\d+\/\d{2}$/;

    if (name === "advocateBarId") {
      if (!barIdPattern.test(value)) {
        setBarIdError("Invalid format. Use 'XX 1234/24'.");
      } else {
        setBarIdError("");
      }
    }

    setAdvocateDetailsAndDocuments({
      ...advocateDetailsAndDocuments,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    console.log(file);

    setAdvocateDetailsAndDocuments((prevState) => ({
      ...prevState,
      [name]: file,
    }));
  };

  const handleSubmitRegistrationForm = async (e) => {
    const validateRegistrationForm = validateAdvocateRegistrationForm(
      advocateDetailsAndDocuments
    );

    const barIdPattern = /^[A-Za-z]{2}\s\d+\/\d{2}$/;

    // Validate advocateBarId format
    if (!barIdPattern.test(advocateDetailsAndDocuments.advocateBarId)) {
      toast.error("Invalid ID");
      return; // Stop submission if format is incorrect
    }

    e.preventDefault();
    if (Object.keys(validateRegistrationForm).length > 0) {
      Object.values(validateRegistrationForm).forEach((error) => {
        toast.error(error);
      });
    } else {
      try {
        debugger;
        setLoading(true);
        const response = await axiosInstance.post(
          `/Registration/registeration_request_advocate_details_and_documents_post`,
          advocateDetailsAndDocuments,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              // Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        );
        console.log(response.data);
        if (response.data.statusCode === 200) {
          toast.success(response.data.status);
          setAdvocateDetailsAndDocuments(
            advocateRegistrationRequestDetailsAndDocumentsInitialState
          );
          setHighestQualification("1");
          handleYearChange(currentYear);
          setShowRegistrationForm(true);
        } else {
          toast.error(response.data.status);
        }
      } catch (error) {
        console.log(error);
        toast.error("failed to submit the registration form please try again");
      } finally {
        console.log(advocateDetailsAndDocuments);
        generateCaptcha();
        setLoading(false);
      }
    }
  };

  // tessst by khalid starts

  // const handleSubmitRegistrationForm = async (e) => {
  //   e.preventDefault();

  //   const barIdPattern = /^[A-Za-z]{2}\s\d+\/\d{2}$/;

  //   // Validate advocateBarId format
  //   if (!barIdPattern.test(advocateDetailsAndDocuments.advocateBarId)) {
  //     toast.error("Invalid ID");
  //     return; // Stop submission if format is incorrect
  //   }

  //   const validateRegistrationForm = validateAdvocateRegistrationForm(
  //     advocateDetailsAndDocuments
  //   );

  //   if (Object.keys(validateRegistrationForm).length > 0) {
  //     Object.values(validateRegistrationForm).forEach((error) => {
  //       toast.error(error);
  //     });
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const response = await axiosInstance.post(
  //       `/Registration/registeration_request_advocate_details_and_documents_post`,
  //       advocateDetailsAndDocuments,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     if (response.data.statusCode === 200) {
  //       toast.success(response.data.status);
  //       setAdvocateDetailsAndDocuments(
  //         advocateRegistrationRequestDetailsAndDocumentsInitialState
  //       );
  //       setHighestQualification("1");
  //       handleYearChange(currentYear);
  //       setShowRegistrationForm(true);
  //     } else {
  //       toast.error(response.data.status);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("Failed to submit the registration form. Please try again.");
  //   } finally {
  //     generateCaptcha();
  //     setLoading(false);
  //   }
  // };

  // test by khalid ends

  const handleHeighestQualificationChange = (e) => {
    const { name, value } = e.target;
    if (value === "1") {
      setAdvocateDetailsAndDocuments({
        ...advocateDetailsAndDocuments,
        postGraduationDegree: "",
        postGraduationPassingYear: 0,
        postGraduationDetails: "",

        doctrateDegree: "",
        doctratePassingYear: 0,
        doctrateDetails: "",
      });
    } else if (value === "2") {
      setAdvocateDetailsAndDocuments({
        ...advocateDetailsAndDocuments,
        doctrateDegree: "",
        doctratePassingYear: 0,
        doctrateDetails: "",
      });
    } else {
      setAdvocateDetailsAndDocuments({ ...advocateDetailsAndDocuments });
    }
    setHighestQualification(value);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <>
      <RegistrationHeader />
      {loading && <Loader />}

      <div className="row justify-content-center mt-5 mb-2">
        <div className="col-xxl-10">
          <div className="row">
            <div className="container mt-4">
              <div
                className="card p-4"
                style={{ backgroundColor: "#f9f9f9", border: "1px solid #ddd" }}
              >
                <h4 className="card-title">
                  Registration Number Format Instructions:
                </h4>
                <p className="card-text">
                  When entering your registration number, please use the
                  following format:
                </p>
                <p
                  className="card-text font-weight-bold"
                  style={{ marginTop: "10px" }}
                >
                  Example: If your registration number is "9999/2024," enter it
                  as "UK 9999/24."
                </p>
                <p className="card-text">Steps:</p>
                <ul
                  className="list-unstyled pl-3"
                  style={{ marginTop: "10px" }}
                >
                  <li>Start with "UK" followed by a single space.</li>
                  <li>Enter the numeric part (e.g., "9999").</li>
                  <li>Add a slash ("/").</li>
                  <li>
                    Enter the last two digits of the year (e.g., "24" from
                    "2024").
                  </li>
                </ul>
                <p className="card-text">
                  Make sure there are no extra spaces or characters.
                </p>

                <h4 className="card-title mt-4">Document Requirements:</h4>
                <ul
                  className="list-unstyled pl-3"
                  style={{ marginTop: "10px" }}
                >
                  <li>All documents must be in PDF format.</li>
                  <li>Documents should be clearly visible and legible.</li>
                </ul>
                <h5 className="mt-4" style={{ color: "red" }}>
                  If you do not follow the above instructions while filling the
                  form, your membership form will not be accepted.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!showRegistrationForm ? (
        <div className="row justify-content-center mt-5">
          <div className="row justify-content-center mb-2">
            <div className="col-xxl-10">
              <div className="row">
                <h3 className="text-center mb-5 text-uppercase">
                  <b>Registration Form</b>
                </h3>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-2">
            <div className="col-xxl-10">
              <div className="row">
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBValidationItem>
                    <MDBInput
                      className="my-1"
                      label="Enter Name"
                      id="name"
                      name="name"
                      value={advocateDetailsAndDocuments.name}
                      onChange={(e) => {
                        handleInputFieldChange(e);
                      }}
                      type="text"
                      required
                    />
                  </MDBValidationItem>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <div className="input-group mb-3">
                    <select
                      className="form-select form-select-sm py-0"
                      style={{
                        height: "calc(1.5em + 0.75rem + 2px)",
                        width: "30%",
                      }}
                      id="relationshipType"
                      name="relationshipType"
                      value={advocateDetailsAndDocuments.relationshipType}
                      onChange={(e) => {
                        handleInputFieldChange(e);
                      }}
                    >
                      <option value="#" selected>
                        select
                      </option>
                      <option value="Son">S/O</option>
                      <option value="Daughter">D/O</option>
                      <option value="Wife">W/O</option>
                    </select>
                    <div
                      className="input-group-append"
                      style={{ width: "70%" }}
                    >
                      <MDBInput
                        label="Relative Name"
                        id="relativeName"
                        name="relativeName"
                        value={advocateDetailsAndDocuments.relativeName}
                        onChange={(e) => {
                          handleInputFieldChange(e);
                        }}
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBInput
                    className="my-1"
                    label="Date of Birth"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={advocateDetailsAndDocuments.dateOfBirth}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="date"
                  />
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBInput
                    className="my-1"
                    label="UK Bar Council Registration Date"
                    id="registrationDate"
                    name="registrationDate"
                    value={advocateDetailsAndDocuments.registrationDate}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="date"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-2">
            <div className="col-xxl-10">
              <div className="row">
                <div className="col-md-3  mt-auto">
                  <MDBInput
                    className="my-1"
                    label="Mobile No"
                    id="mobileNo"
                    name="mobileNo"
                    value={advocateDetailsAndDocuments.mobileNo}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="number"
                  />
                </div>
                <div className="col-md-3  mt-auto">
                  <MDBInput
                    className="my-1"
                    label="Email"
                    id="email"
                    name="email"
                    value={advocateDetailsAndDocuments.email}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="email"
                  />
                </div>
                <div className=" col-md-3 ">
                  <label className="" htmlFor="bloodgroup">
                    Blood Group
                  </label>
                  <select
                    className="form-control"
                    id="bloodGroup"
                    name="bloodGroup"
                    value={advocateDetailsAndDocuments.bloodGroup}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                  >
                    <option value="" selected>
                      Select
                    </option>
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                  </select>
                </div>
                {/* <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                  <MDBInput
                    className="my-1"
                    label="UK Bar Counciling Reg No."
                    id="advocateBarId"
                    name="advocateBarId"
                    value={advocateDetailsAndDocuments.advocateBarId}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="text"
                  />
                </div> */}
                <div className="col-sm-6 col-md-4 col-xl-3 mt-auto">
                  <MDBInput
                    className="my-1"
                    label="UK Bar Counciling Reg No."
                    id="advocateBarId"
                    name="advocateBarId"
                    value={advocateDetailsAndDocuments.advocateBarId}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="text"
                  />
                  {barIdError && (
                    <p className="text-danger mt-1">{barIdError}</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-2">
            <div className="col-xxl-10">
              <div data-mdb-input-init className="form-outline">
                <label className="form-label" htmlFor="textAreaExample3">
                  Address
                </label>
                <MDBTextArea
                  className="form-control"
                  id="permanentAddress"
                  name="permanentAddress"
                  value={advocateDetailsAndDocuments.permanentAddress}
                  onChange={(e) => {
                    handleInputFieldChange(e);
                  }}
                  rows="2"
                />
              </div>
            </div>
          </div>

          <div className="row justify-content-center mt-2">
            <div className="col-xxl-10">
              <p className="fw-bolder m-0">
                Educational Qualification
                <span className="text-danger">
                  (Please select highest Educational Qualification)
                </span>
              </p>
            </div>
          </div>

          <div className="row justify-content-center mb-3 mt-3">
            <div className="col-xxl-10">
              <div className="row">
                <div className="col-md-3  mt-auto">
                  <label className="form-label">
                    {" "}
                    Select Highest Educational Qualification
                  </label>
                  <select
                    className="form-control"
                    onChange={(e) => {
                      handleHeighestQualificationChange(e);
                    }}
                  >
                    <option value="0">Select</option>
                    <option value="1">Graduation</option>
                    <option value="2">Post Graduation</option>
                    <option value="3">Doctorate</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-3">
            <div className="col-xxl-10">
              <div className="row">
                <div className="col-md-9  mt-auto">
                  <MDBTextArea
                    label="High School Details"
                    rows={2}
                    id="highSchoolDetails"
                    name="highSchoolDetails"
                    value={advocateDetailsAndDocuments.highSchoolDetails}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="text"
                  />
                </div>
                <div className="col-md-3  mt-auto">
                  <label className="form-label">
                    HighSchool completeion Year
                  </label>

                  <YearPicker
                    selectedYear={selectedYear}
                    value={advocateDetailsAndDocuments.highSchoolPassingYear}
                    onChange={(e) => {
                      handleYearChange();
                      setAdvocateDetailsAndDocuments({
                        ...advocateDetailsAndDocuments,
                        highSchoolPassingYear: e,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-3">
            <div className="col-xxl-10">
              <div className="row">
                <div className="col-md-9  mt-auto">
                  <MDBTextArea
                    label="Intermediate Details "
                    rows={2}
                    id="intermediateDetails"
                    name="intermediateDetails"
                    value={advocateDetailsAndDocuments.intermediateDetails}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="text"
                  />
                </div>
                <div className="col-md-3  mt-auto">
                  <label className="form-label">
                    Intermediate completeion Year
                  </label>
                  <YearPicker
                    selectedYear={selectedYear}
                    value={advocateDetailsAndDocuments.intermediatePassingYear}
                    onChange={(e) => {
                      handleYearChange();
                      setAdvocateDetailsAndDocuments({
                        ...advocateDetailsAndDocuments,
                        intermediatePassingYear: e,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-3">
            <div className="col-xxl-10">
              <div className="row">
                <div className="col-md-9  mt-auto">
                  <MDBTextArea
                    label="Graduation Details "
                    rows={2}
                    id="graduationDetails"
                    name="graduationDetails"
                    value={advocateDetailsAndDocuments.graduationDetails}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="text"
                  />
                </div>
                <div className="col-md-3  mt-auto">
                  <div className="row">
                    <div className="col-6 mt-auto">
                      <label className="form-label">Graduation</label>
                      <select
                        className="form-control"
                        id="graduationDegree"
                        name="graduationDegree"
                        value={advocateDetailsAndDocuments.graduationDegree}
                        onChange={(e) => {
                          handleInputFieldChange(e);
                        }}
                      >
                        <option value="0">Select</option>
                        <option value="BA LLB">BA LLB</option>
                        <option value="BBA LLB">BBA LLB</option>
                        <option value="BSc LLB">BSc LLB</option>
                        <option value="LLB">LLB</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="col-6 mt-auto">
                      <label className="form-label">Completeion Year</label>
                      <YearPicker
                        selectedYear={selectedYear}
                        value={
                          advocateDetailsAndDocuments.graduationPassingYear
                        }
                        onChange={(e) => {
                          handleYearChange();
                          setAdvocateDetailsAndDocuments({
                            ...advocateDetailsAndDocuments,
                            graduationPassingYear: e,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {parseInt(highestQualification) >= 2 &&
            parseInt(highestQualification) <= 3 && (
              <div className="row justify-content-center mb-3">
                <div className="col-xxl-10">
                  <div className="row">
                    <div className="col-md-9  mt-auto">
                      <MDBTextArea
                        label="Post Graduation Details "
                        rows={2}
                        id="postGraduationDetails"
                        name="postGraduationDetails"
                        value={
                          advocateDetailsAndDocuments.postGraduationDetails
                        }
                        onChange={(e) => {
                          handleInputFieldChange(e);
                        }}
                        type="text"
                      />
                    </div>
                    <div className="col-md-3  mt-auto">
                      <div className="row">
                        <div className="col-6 mt-auto">
                          <label className="form-label">Post Graduation</label>
                          <select
                            className="form-control"
                            id="postGraduationDegree"
                            name="postGraduationDegree"
                            value={
                              advocateDetailsAndDocuments.postGraduationDegree
                            }
                            onChange={(e) => {
                              handleInputFieldChange(e);
                            }}
                          >
                            <option value="0">Select</option>
                            <option value="LLM"> LLM</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        <div className="col-6 mt-auto">
                          <label className="form-label">Completeion Year</label>
                          <YearPicker
                            selectedYear={selectedYear}
                            value={
                              advocateDetailsAndDocuments.postGraduationPassingYear
                            }
                            onChange={(e) => {
                              handleYearChange();
                              setAdvocateDetailsAndDocuments({
                                ...advocateDetailsAndDocuments,
                                postGraduationPassingYear: e,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

          {parseInt(highestQualification) === 3 && (
            <div className="row justify-content-center mb-3">
              <div className="col-xxl-10">
                <div className="row">
                  <div className="col-md-9  mt-auto">
                    <MDBTextArea
                      label="Doctorate Details"
                      rows={2}
                      id="doctrateDetails"
                      name="doctrateDetails"
                      value={advocateDetailsAndDocuments.doctrateDetails}
                      onChange={(e) => {
                        handleInputFieldChange(e);
                      }}
                      type="text"
                    />
                  </div>
                  <div className="col-md-3  mt-auto">
                    <div className="row">
                      <div className="col-6 mt-auto">
                        <label className="form-label">Doctorate</label>
                        <select
                          className="form-control"
                          id="doctrateDegree"
                          name="doctrateDegree"
                          value={advocateDetailsAndDocuments.doctrateDegree}
                          onChange={(e) => {
                            handleInputFieldChange(e);
                          }}
                        >
                          <option value="0">Select</option>
                          <option value="L.L.D"> L.L.D</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="col-6 mt-auto">
                        <label className="form-label">Completeion Year</label>
                        <YearPicker
                          selectedYear={selectedYear}
                          value={
                            advocateDetailsAndDocuments.doctratePassingYear
                          }
                          onChange={(e) => {
                            handleYearChange();
                            setAdvocateDetailsAndDocuments({
                              ...advocateDetailsAndDocuments,
                              doctratePassingYear: e,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row justify-content-center mb-2 mt-3">
            <div className="col-xxl-10">
              <p className="fw-bolder m-0">
                With Which Advocate you are working with in the Dehradun Court
                (Experience of the concerned should be at least 10 years and
                should be the member of the Bar Association, Deharadun)
              </p>
            </div>
          </div>

          <div className="row justify-content-center mb-2">
            <div className="col-xxl-10">
              <div className="row">
                <div className="col-md-3  mt-auto">
                  <MDBInput
                    className="my-1"
                    label="Mentor Advocate Name"
                    id="mentorAdvocateName"
                    name="mentorAdvocateName"
                    value={advocateDetailsAndDocuments.mentorAdvocateName}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="text"
                  />
                </div>
                <div className="col-md-3  mt-auto">
                  <MDBInput
                    label="Bar Registration Id"
                    id="mentorAdvocateBarId"
                    name="mentorAdvocateBarId"
                    value={advocateDetailsAndDocuments.mentorAdvocateBarId}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="text"
                  />
                </div>
                <div className="col-md-3 ">
                  <MDBInput
                    className="my-1"
                    label="Date"
                    id="mentorJoiningDate"
                    name="mentorJoiningDate"
                    value={advocateDetailsAndDocuments.mentorJoiningDate}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="date"
                  />
                </div>
                <div className="col-md-3  mt-auto">
                  <MDBInput
                    className="my-1"
                    label="Chamber No"
                    id="chamberNo"
                    name="chamberNo"
                    value={advocateDetailsAndDocuments.chamberNo}
                    onChange={(e) => {
                      handleInputFieldChange(e);
                    }}
                    type="number"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-2 mt-4">
            <div className="col-xxl-10">
              {/* <p className="fw-bolder m-0">Is the Applicatnt retired from any Department ? if yes</p> */}
              <MDBCheckbox
                name="isRetired"
                checked={isRetiredFromAnyDepartment}
                id="isRetired"
                label="Is the Applicant retired from any Department? If yes"
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setIsRetiredFromAnyDepartment(isChecked);
                  setAdvocateDetailsAndDocuments((prevState) => ({
                    ...prevState,
                    isRetiredFromAnyDepartment: isChecked,
                  }));
                }}
                labelClass="text-dark"
              />
            </div>
          </div>

          {isRetiredFromAnyDepartment && (
            <div className="row justify-content-center mb-2 ">
              <div className="col-xxl-10">
                <div className="row mt-1">
                  <div className="col-md-3  mt-auto">
                    <MDBInput
                      className="my-1"
                      label="Name of Department"
                      id="previousDepartment"
                      name="previousDepartment"
                      value={advocateDetailsAndDocuments.previousDepartment}
                      onChange={(e) => {
                        handleInputFieldChange(e);
                      }}
                      type="text"
                    />
                  </div>
                  <div className="col-md-3  mt-auto">
                    <label>Retirement Year</label>
                    <YearPicker
                      selectedYear={selectedYear}
                      value={advocateDetailsAndDocuments.retirementYear}
                      onChange={(e) => {
                        handleYearChange();
                        setAdvocateDetailsAndDocuments({
                          ...advocateDetailsAndDocuments,
                          retirementYear: e,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row justify-content-center mt-2">
            <div className="col-xxl-10">
              <p className="fw-bolder m-0">
                Upload Required Documents{" "}
                <span className="text-danger">
                  (All document must be in PDF format and should be clearly
                  visible and legible)
                </span>
              </p>
            </div>
          </div>

          <div className="row justify-content-center mb-2 mt-3">
            <div className="col-xxl-10">
              <div className="row mt-1">
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBFile
                    required
                    className="my-1"
                    label="Upload Aadhar"
                    id="aadharDocument"
                    name="aadharDocument"
                    type="file"
                    onChange={(e) => {
                      handleFileChange(e);
                    }}
                  />
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBFile
                    required
                    className="my-1"
                    label="Upload Highschool Certificate"
                    id="highSchoolDocument"
                    name="highSchoolDocument"
                    type="file"
                    onChange={(e) => {
                      handleFileChange(e);
                    }}
                  />
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBFile
                    required
                    className="my-1"
                    label="Upload Intermediate Certificate"
                    id="intermediateDocument"
                    name="intermediateDocument"
                    type="file"
                    onChange={(e) => {
                      handleFileChange(e);
                    }}
                  />
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBFile
                    required
                    className="my-1"
                    label="Upload Graduation Certificate"
                    id="graduationDocument"
                    name="graduationDocument"
                    type="file"
                    onChange={(e) => {
                      handleFileChange(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-2 mt-3">
            <div className="col-xxl-10">
              <div className="row mt-1">
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBFile
                    required
                    className="my-1"
                    label="Upload AIBE Certificate"
                    id="aibeCertificate"
                    name="aibeCertificate"
                    type="file"
                    onChange={(e) => {
                      handleFileChange(e);
                    }}
                  />
                </div>

                <div className="col-sm-6 col-md-4 col-xl-3">
                  <MDBFile
                    required
                    className="my-1"
                    label="Upload Affidavit"
                    id="affidavitDocument"
                    name="affidavitDocument"
                    type="file"
                    onChange={(e) => {
                      handleFileChange(e);
                    }}
                  />
                </div>

                {parseInt(highestQualification) >= 2 &&
                  parseInt(highestQualification) <= 3 && (
                    <div className="col-sm-6 col-md-4 col-xl-3">
                      <MDBFile
                        required
                        className="my-1"
                        label="Upload Post Graduation Certificate"
                        id="postGraduationDocument"
                        name="postGraduationDocument"
                        type="file"
                        onChange={(e) => {
                          handleFileChange(e);
                        }}
                      />
                    </div>
                  )}

                {parseInt(highestQualification) == 3 && (
                  <div className="col-sm-6 col-md-4 col-xl-3">
                    <MDBFile
                      required
                      className="my-1"
                      label="Upload Doctorate Certificate"
                      id="doctrateDocument"
                      name="doctrateDocument"
                      value={advocateDetailsAndDocuments.doctrate}
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row justify-content-center mb-2 mt-3">
            <div className="col-xxl-10">
              <div className="checkbox-container">
                <MDBCheckbox
                  labelClass="text-dark"
                  name="flexCheck"
                  value=""
                  id="flexCheckDefault"
                  label="I declare at Dehradun that the above details given by me are true and correct. I will follow the rules properly. If any falsehood is found in the details given by me All actions taken by the Bar Association will be fully acceptable to me After 6 month, he/she will present the advocacy experience certificate from the concerned advocate to the Secretary. Therefore, you are requested to please grant membership of Bar Association, Dehradun to the applicant."
                  defaultChecked
                />
              </div>

              {/* <p className="fw-bolder m-0">I declare at Dehradun that the above details given by me are true and correct. I will follow the rules properly. If any falsehood is found in the details given by me All actions taken by the Bar Association will be fully acceptable to me After 6 month, he/she will present the advocacy experience certificate from the concerned advocate to the Secretary. Therefore, you are requested to please grant membership of Bar Association, Dehradun to the applicant. </p> */}
            </div>
          </div>

          <>
            <div className="row justify-content-center mt-3">
              <div className="col-xxl-10 mb-0">
                <div className="row justify-content-center mb-0">
                  <div className="col-md-3 d-flex justify-content-center mb-0">
                    <p
                      className="text-center"
                      id="status"
                      style={{ color: "#ee7e6a" }}
                    >
                      {status}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-xxl-10 mb-0">
                <div className="row justify-content-center mb-0">
                  <div className="col-md-3 d-flex justify-content-center mb-0">
                    <input
                      type="text"
                      readOnly
                      id="generated-captcha"
                      value={captcha}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center my-2">
              <div className="col-xxl-10">
                <div className="row justify-content-center ">
                  <div className="col-md-3 d-flex justify-content-center mb-0">
                    <MDBInput
                      type="text"
                      label="Enter Captcha"
                      labelClass="text-center"
                      className="text-center py-2"
                      value={userInput}
                      onChange={(e) => setUserInput(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <button type="button" onClick={checkCaptcha}>Check</button>
      <button type="button" onClick={generateCaptcha} id="gen">Generate New</button> */}
          </>

          <div className="row justify-content-center mb-2 mt-3">
            <div className="col-xxl-10">
              <div className="row justify-content-center my-5">
                <div className="col-md-4 mb-1 d-flex justify-content-center">
                  <MDBBtn
                    onClick={(e) => {
                      checkCaptcha(e);
                    }}
                  >
                    Submit Registration Form{" "}
                  </MDBBtn>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="col-sm-3 text-center">
            <MDBBtn
              onClick={() => {
                setShowRegistrationForm(false);
              }}
            >
              Apply
            </MDBBtn>
          </div>
        </div>
      )}
    </>
  );
};

export default Registration;
